import React, { CSSProperties, FunctionComponent } from 'react';
import { LogoBox } from './AgentLogo.style';

interface Props {
  image?: string;
  color?: string;
  size: number;
  containerStyle?: CSSProperties;
}

const AgentLogo: FunctionComponent<Props> = (props) => {
  return (
    <LogoBox
      style={{
        width: props.size,
        height: props.size,
        backgroundImage: `url(${props.image})`,
        backgroundColor: props.color,
        ...props.containerStyle,
      }}
    />
  );
};

export default AgentLogo;
